/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeADownLeftIcon16Solid = forwardRef('ArrowShapeADownLeftIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M12.535 14H4a2 2 0 0 1-2-2V3.466c0-1.025 1.24-1.538 1.964-.814l1.85 1.85 2.7-2.7a1.75 1.75 0 0 1 2.475 0l3.21 3.21a1.75 1.75 0 0 1 0 2.475l-2.7 2.7 1.85 1.85c.724.724.21 1.963-.814 1.963Z" })));
});
